import React from "react";
import { useTranslation } from "react-i18next";
const EvenOrOddTable = ({winningPlanArray}) => {
  const { t } = useTranslation();
  const getValueByBetType = (a, b, c) => {
    let x;
    c.map(item => {
      if (item.BetType === a && item.Specifier === b) x = item.Value;
      return item;
    });
    return x;
  };
  return (
    <div className="luckysix-container">
      {t("betContent.evenOddTable.moreEvenOddBalls")}
      <div className="pay-table-label-dark pay-table-line">
        {t("betContent.evenOddTable.forAllBallsDrawn")}
      </div>
      <div className="pay-table-label-dark-smaller">
        {t("betContent.evenOddTable.moreEvenBalls")} - {getValueByBetType(11, 1, [...winningPlanArray])} x {t("stakeUPER")}
      </div>
      <div className="pay-table-label-dark-smaller">
      {t("betContent.evenOddTable.moreOddBalls")} - {getValueByBetType(11, 2, [...winningPlanArray])} x {t("stakeUPER")}
      </div>
    </div>
  );
};

export default EvenOrOddTable;